export const GET_TIME_ENTRIES_WEEK = 'GET_TIME_ENTRIES_WEEK';
export const GET_TIME_ENTRIES_PERIOD = 'GET_TIME_ENTRIES_PERIOD';
export const ADD_TIME_ENTRY = 'ADD_TIME_ENTRY';
